import { Subject } from 'rxjs'

import { renderDatatable } from './datatable.render'

export const ReactDatatableComponent = (() => {
	const datatableFetchData$$ = new Subject()

	const fetch = () => {
		datatableFetchData$$.next()
	}

	const datatableFetchData$ = () => datatableFetchData$$.asObservable()

	const init = () => {
		renderDatatable()
	}

	return {
		init,
		fetch,
		datatableFetchData$,
	}
})()
